import { render, staticRenderFns } from "./PurchaseMinimum.vue?vue&type=template&id=3a42755e&scoped=true&"
import script from "./PurchaseMinimum.vue?vue&type=script&lang=js&"
export * from "./PurchaseMinimum.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseMinimum.vue?vue&type=style&index=0&id=3a42755e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a42755e",
  null
  
)

export default component.exports